import {createRouter, createWebHistory} from '@ionic/vue-router';
import store from '../services/store';

const routes = [
    {
        path: '/',
        redirect: (to) => {
            // If store is not initialized yet, redirect to login by default
            // The router guard will handle proper redirection once store is ready
            if (!store.getters.initialized) {
                return '/login';
            }
            // Check if user is authenticated
            if (store.getters.authenticated) {
                return '/home';
            } else {
                return '/login';
            }
        },
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import('../views/HomePage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/notifications',
        name: 'Notifications',
        component: () => import('../views/NotificationsPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/efficiency',
        name: 'Efficiency',
        component: () => import('../views/EfficiencyPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/management/mitarbeiter',
        name: 'MitarbeiterManagement',
        component: () => import('../views/PersonnelManagementPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/meine-uebungen',
        name: 'MeineUebungen',
        component: () => import('../views/MyExercisesPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/uebungskatalog',
        // Route names must be unique: Vue Router silently drops the earlier
        // route when a name is reused. This one was called 'ExerciseCatalog'
        // first, which collided with the (now removed) legacy workout route
        // and left the page unreachable.
        name: 'Uebungskatalog',
        component: () => import('../views/ExerciseCatalogPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        // Work through patients' exercise lists in the practice, in slots.
        path: '/training',
        name: 'Training',
        component: () => import('../views/TrainingPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/gutscheine',
        name: 'GutscheinVerwaltung',
        component: () => import('../views/GutscheinVerwaltungPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/gutscheine/ausgabe',
        name: 'GutscheinAusgabe',
        component: () => import('../views/GutscheinAusgabePage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/gutscheine/einloesen',
        name: 'GutscheinEinloesen',
        component: () => import('../views/GutscheinEinloesenPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/timetracking',
        name: 'TimeTracking',
        component: () => import('../views/TimeTrackingPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/timetracking/:id',
        name: 'TimeTrackingEntry',
        component: () => import('../views/TimeTrackingEditPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/absence',
        name: 'Absence',
        component: () => import('../views/AbsencePage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/illness',
        name: 'Illness',
        component: () => import('../views/IllnessPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/chat',
        name: 'Chat',
        component: () => import('../views/ChatPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/admin',
        name: 'AdministrationPage',
        component: () => import('../views/AdministrationPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/settings',
        name: 'SettingsPage',
        component: () => import('../views/SettingsPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/settings/administration',
        name: 'SettingsAdminPage',
        component: () => import('../views/SettingsAdminPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/settings/administration/organization/:id',
        name: 'SettingsAdminOrgPage',
        component: () => import('../views/SettingsAdminOrgPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/settings/administration/user/:id',
        name: 'SettingsAdminUserPage',
        component: () => import('../views/SettingsAdminUserPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/settings/administration/organization/:id/newuser',
        name: 'SettingsAdminNewUserPage',
        component: () => import('../views/SettingsAdminNewUserPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/hrmngment',
        name: 'Personalverwaltung',
        component: () => import('../views/PersonellManagementPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/hrmngment/edit/:id',
        name: 'PersonalverwaltungEdit',
        component: () => import('../views/PersonellManagementEditPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/patientmngment',
        name: 'Patientenverwaltung',
        component: () => import('../views/PatientManagementPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/patientmngment/edit/:id',
        name: 'PatientenverwaltungEdit',
        component: () => import('../views/PatientManagementEditPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/recipes/',
        name: 'Rezepte',
        component: () => import('../views/RecipesPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/users/:id',
        name: 'Benutzerdaten',
        component: () => import('../views/UserdataPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/recipes/edit/:id',
        name: 'RezeptEdit',
        component: () => import('../views/RecipeEditPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/recipes/registration/:id',
        name: 'RezeptRegistration',
        component: () => import('../views/RecipeRegistrationPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/appointments/',
        name: 'Termine',
        component: () => import('../views/AppointmentsPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/controlappointments/',
        name: 'Termineverwaltung',
        component: () => import('../views/AppointmentsControlPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/controlappointments/:id',
        name: 'Termine Absagen',
        component: () => import('../views/TherapistsAppointments.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/documents/:id?',
        name: 'Dokumente',
        component: () => import('../views/DocumentsPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/invoices/',
        name: 'Rechnungen',
        component: () => import('../views/InvoicesPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/development/',
        name: 'Entwicklung',
        component: () => import('../views/Development/DevelopmentPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/verordnungsservice/',
        name: 'Verordnungsservice',
        component: () => import('../views/Verordnungsservice/VerordnungsservicePage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/invoices/:invoice_id/',
        name: 'Rechnung',
        component: () => import('../views/InvoiceDetails.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/verordnungen/therapiebericht/:prescription_id',
        name: 'Therapiebericht',
        component: () => import('../views/Therapiebericht/TherapieberichtPage.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/LoginPage.vue'),
    },
    {
        path: '/set_password/:email',
        name: 'SetPassword',
        component: () => import('../views/SetPassword.vue'),
    },
    {
        path: '/employee_list/',
        name: 'EmployeeList',
        component: () => import('../views/UserListPage.vue'),
    },
    {
        path: '/patient_list/',
        name: 'PatientList',
        component: () => import('../views/UserListPage.vue'),
    },
    {
        path: '/management',
        redirect: '/management/patientenmanagement',
    },
    {
        path: '/management/patientenmanagement',
        name: 'PatientsManagementPage',
        component: () => import('../views/PatientsManagementPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/management/arztmanagement',
        name: 'DoctorsManagementPage',
        component: () => import('../views/DoctorsManagementPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/profile',
        name: 'UserProfile',
        component: () => import('../views/UserProfilePage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/help',
        name: 'Help',
        component: () => import('../views/HelpPage.vue'),
        meta: { requiresAuth: true },
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
